module.exports = __webpack_public_path__ + "img/marieSteiner.b25c9875.png";